import React from 'react'
import Flatpickr from 'react-flatpickr'
import { connect } from 'react-redux'
import { getContent } from 'app/state/modules/content'
import { addPlanGroup, updatePlanGroup } from 'app/state/modules/plan'
import { getTeamPlanDetail } from 'app/state/modules/team'
import UIkit from 'uikit'


class AddPhase extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      title: '',
      description: '',
      startDate: null,
      endDate: null,
      duration: '',
      contentIds: [],
    }

    this.handleChangeTitle = this.handleChangeTitle.bind(this)
    this.handleChangeDescription = this.handleChangeDescription.bind(this)
    this.handleChangeStartDate = this.handleChangeStartDate.bind(this)
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this)
    this.handleSubmitSave = this.handleSubmitSave.bind(this)
    this.handleChangeDuration = this.handleChangeDuration.bind(this)
  }

  componentDidMount() {
    this.props.getContent()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isEdit !== false) {
      const {
        duration,
        phase_title: title,
        description = '',
        start_date: startDate,
        end_date: endDate,
        content,
      } = nextProps.isEdit
      this.setState({
        error: '',
        title,
        description,
        startDate,
        endDate,
        duration,
        contentIds: content.map(({ content_uuid: contentUUID }) => contentUUID),
      }, () => {
        this.activateDragListeners()
      })
    } else {
      this.setState({
        error: '',
        title: '',
        description: '',
        startDate: null,
        endDate: null,
        duration: '',
        contentIds: [],
      }, () => this.activateDragListeners())
    }
  }

  activateDragListeners() {
    UIkit.util.on('#content-list', 'moved', (x) => {
      const contentIds = []
      for (let child of x.target.children) {
        contentIds.push(child.id)
      }
      this.setState({ contentIds })
    })
    UIkit.util.on('#content-list', 'added', (x) => {
      const contentIds = []
      for (let child of x.target.children) {
        contentIds.push(child.id)
      }
      this.setState({ contentIds })
    })
    UIkit.util.on('#content-list', 'removed', (x) => {
      const contentIds = []
      for (let child of x.target.children) {
        contentIds.push(child.id)
      }
      this.setState({ contentIds })
    })
  }

  handleChangeTitle(event) {
    this.setState({ title: event.target.value })
  }

  handleChangeDescription(event) {
    this.setState({ description: event.target.value })
  }

  handleChangeDuration(event) {
    this.setState({ duration: event.target.value.replace(/[^0-9]+/g, '') })
  }

  handleChangeStartDate(date) {
    this.setState({ startDate: date[0] })
  }

  handleChangeEndDate(date) {
    this.setState({ endDate: date[0] })
  }

  handleSubmitSave(event) {
    event.preventDefault()

    if (this.props.isTimeBased) {
      if (this.state.duration === '' || isNaN(parseInt(this.state.duration, 10)) || parseInt(this.state.duration, 10) < 1) {
        this.setState({ error: 'Duration is required and can\'t be less than 1.' })
        return
      }
    }

    if (!this.props.isTimeBased && this.state.startDate && this.state.endDate) {
      if (this.state.endDate < this.state.startDate) {
        this.setState({ error: 'End date of phase cannot be before start date' })
        return
      }
    }


    if (this.state.title === '') {
      this.setState({ error: 'Title is required.' })
    } else {
      // if (this.props.planMap[this.props.match.params.plan_uuid].groups.length === 0) {
      //   UIkit.modal('#modal-plan-created').show()
      // }

      let startDate = null
      if (this.state.startDate !== null) {
        startDate = this.state.startDate.toISOString().slice(0, 10)
      }

      let endDate = null
      if (this.state.endDate !== null) {
        endDate = this.state.endDate.toISOString().slice(0, 10)
      }

      if (this.props.isEdit === false) {
        this.props.addPlanGroup(
          this.props.match.params.organization_uuid,
          this.props.planUUID,
          this.state.title,
          this.state.description,
          startDate,
          endDate,
          this.state.contentIds,
          this.state.duration,
        ).then(() => {
          this.props.getTeamPlanDetail(
            this.props.match.params.organization_uuid,
            this.props.match.params.team_uuid,
          )
          this.setState({
            error: '',
            title: '',
            description: '',
            startDate: null,
            endDate: null,
            duration: '',
            contentIds: [],
          })
          this.props.hide()
        })
      } else {
        this.props.updatePlanGroup(
          this.props.match.params.organization_uuid,
          this.props.planUUID,
          this.props.isEdit.uuid,
          this.state.title,
          this.state.description,
          startDate,
          endDate,
          this.state.contentIds,
          this.state.duration,
        )
          .then(() => {
            this.props.getTeamPlanDetail(
              this.props.match.params.organization_uuid,
              this.props.match.params.team_uuid,
            )
            this.props.hide()
          })
      }
    }
  }

  render() {
    return (
      <div>
        <p className="">
          You can break up your training into different "phases". Choose which lessons you
          would like for the phase, and optionally set an end date for these lessons.
        </p>
        <div className="uk-container">
          <form className="uk-form-stacked">
            <div className="uk-margin">
              <label className="uk-form-label">
                Phase Title
                <button
                  type="button"
                  href="#"
                  data-uk-icon="icon: info; ratio: 0.8"
                  data-uk-toggle="target: #modal-training-phase"
                  style={{ marginLeft: 8 }}
                />
              </label>
              <div className="uk-form-controls">
                <input
                  data-test-id="input-phase-title"
                  className="uk-input"
                  type="text"
                  placeholder=""
                  value={this.state.title}
                  onChange={this.handleChangeTitle}
                />
              </div>
              <div id="modal-training-phase" data-uk-modal>
                <div className="uk-modal-dialog uk-modal-body">
                  <h2 >What is a Training Phase?</h2>
                  <p>
                    You can break up your training into different "phases". Choose which
                    lessons you would like for the phase, and optionally set an end date for
                    these lessons.
                  </p>
                  <p className="uk-text-right">
                    <button className="uk-button uk-button-primary uk-modal-close" type="button">Ok</button>
                  </p>
                  <button className="uk-modal-close-outside" type="button" data-uk-close />
                </div>
              </div>
            </div>

            <div className="uk-margin">
              <label className="uk-form-label">Phase Description</label>
              <div className="uk-form-controls">
                <input
                  data-test-id="input-phase-description"
                  className="uk-input"
                  type="text"
                  placeholder=""
                  value={this.state.description}
                  onChange={this.handleChangeDescription}
                />
              </div>
              <span className="uk-text-meta">The description shows up on your users' My Plan dashboard.</span>
            </div>

            {this.props.isTimeBased === false ? (
              <>
                <div className="uk-margin">
                  <label className="uk-form-label">Phase Start Date</label>
                  <div className="uk-form-controls">
                    <Flatpickr
                      className="uk-input"
                      value={this.state.startDate}
                      onChange={this.handleChangeStartDate}
                    />
                  </div>
                  <span className="uk-text-meta">The start date is used for training reminders.</span>
                </div>

                <div className="uk-margin">
                  <label className="uk-form-label">Phase End Date</label>
                  <div className="uk-form-controls">
                    <Flatpickr
                      className="uk-input"
                      value={this.state.endDate}
                      onChange={this.handleChangeEndDate}
                    />
                  </div>
                  <span className="uk-text-meta">The end date is used for training reminders.</span>
                </div>
              </>
            )
              : (
                <div className="uk-margin">
                  <label className="uk-form-label">Duration in days</label>
                  <div className="uk-form-controls">
                    <input
                      data-test-id="input-phase-description"
                      className="uk-input"
                      type="text"
                      placeholder=""
                      value={this.state.duration}
                      onChange={this.handleChangeDuration}
                    />
                  </div>
                  <span className="uk-text-meta">The duration that a user has to complete the phase after on-boarding.</span>
                </div>
              )}
            <div className="uk-margin">

              <div className="uk-form-controls">
                <div className="uk-child-width-1-2@s" data-uk-grid>
                  <div>
                    <label className="uk-form-label">
                      Choose Lessons
                      <a
                        href="#"
                        data-uk-icon="icon: info; ratio: 0.8"
                        data-uk-toggle="target: #modal-choose-lessons"
                        style={{ marginLeft: 8 }}
                      />
                    </label>
                    <div data-test-id="choose-lesson-left" className="uk-placeholder uk-padding-small">
                      {Object.keys(this.props.content).length > 0 && Object.keys(this.props.content).map((contentKey) => {
                        if (contentKey === 'courses') {
                          return (
                            <div key={contentKey}>
                              <b>{contentKey.charAt(0).toUpperCase() + contentKey.slice(1)}</b>
                              {this.props.content[contentKey].map((course) => {
                                return (
                                  <React.Fragment key={course.uuid}>
                                    <ul className="uk-nav uk-nav-default uk-width-medium" data-uk-sortable="group: sortable-group">
                                      <li className="uk-disabled uk-active" style={{ marginLeft: 10 }}>
                                        {course.title}
                                      </li>
                                      {course.items.map((item) => {
                                        if (item.item_type === 'content') {
                                          return (
                                            <li className="uk-drag uk-margin-left" key={item.uuid} id={item.uuid}>
                                              <a href="#" id={item.uuid}>{item.title}</a>
                                            </li>
                                          )
                                        }
                                        return item.content.map((lessonContent) => (
                                          <li className="uk-drag uk-margin-left" key={lessonContent.uuid} id={lessonContent.uuid}>
                                            <a href="#" id={lessonContent.uuid}>{lessonContent.title}</a>
                                          </li>
                                        ))
                                      })}
                                    </ul>
                                  </React.Fragment>
                                )
                              })}
                            </div>
                          )
                        }
                        return (
                          <div key={contentKey}>
                            <b>{contentKey.charAt(0).toUpperCase() + contentKey.slice(1)}</b>
                            <ul className="uk-nav uk-nav-default uk-width-medium" data-uk-sortable="group: sortable-group">
                              {this.props.content[contentKey].map((item) => (
                                <li className="uk-drag uk-margin-left" key={item.uuid} id={item.uuid}>
                                  <a href="#" id={item.uuid}>{item.title}</a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  <div>
                    <label className="uk-form-label">Selected Lessons</label>
                    <ul data-test-id="choose-lesson-right" className="uk-placeholder uk-padding-small uk-nav uk-nav-default" id="content-list" data-uk-sortable="group: sortable-group" style={{ minHeight: 'calc(100% - 80px)' }} >

                      {this.props.isEdit !== false && this.props.isEdit.content.map(content => (
                        <li className="uk-drag" key={content.content_uuid} id={content.content_uuid}>
                          <a href="#" id={content.content_uuid}>
                            {content.content_title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div id="modal-choose-lessons" data-uk-modal>
                <div className="uk-modal-dialog uk-modal-body">
                  <h2 >Choose Lessons</h2>
                  <p>
                    Drag lessons from the left column into the "Selected Lessons" column to
                    add them to your training plan. Drag the lessons up and down to order
                    them.
                  </p>
                  <p className="uk-text-right">
                    <button className="uk-button uk-button-primary uk-modal-close" type="button">Ok</button>
                  </p>
                  <button className="uk-modal-close-outside" type="button" data-uk-close></button>
                </div>
              </div>
            </div>
            {(this.state.error !== '') && (
              <div className="uk-margin">
                <p className="uk-text-danger">{this.state.error}</p>
              </div>
            )}
          </form>
          <p className="uk-text-right">
            {this.props.isEdit && (
              <button
                className="uk-button uk-button-danger uk-align-left"
                type="button"
                onClick={() => {
                  this.props.hide()
                  this.props.deletePhaseModal.show()
                }}
              >
                Delete Phase
              </button>
            )}
            <button
              className="uk-button uk-button-default uk-margin-remove-bottom uk-modal-close"
              onClick={this.props.hide}
              type="button"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={this.handleSubmitSave}
              className="uk-button uk-button-primary uk-margin-left"
            >
              {this.props.isEdit ? 'Save phase' : 'Create phase'}
            </button>
          </p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  content: state.content.content,
  courses: state.content.courses,
  lessonMap: state.content.lessonMap,
})

export default connect(mapStateToProps, {
  getContent,
  addPlanGroup,
  getTeamPlanDetail,
  updatePlanGroup,
})(AddPhase)
